import React from "react"
import classnames from "classnames"
import { Element } from "react-scroll"

function HeroWrapper({ theme, children, ...rest }) {
  return (
    <Element id={rest.id}>
      <section
        className={classnames(
          `hero`,
          theme === "light"
            ? "is-light has-text-dark"
            : "is-dark has-text-light",
          `is-bold`,
          `is-fullheight`
        )}
        {...rest}
      >
        {children}
      </section>
    </Element>
  )
}

export default HeroWrapper
